import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Spinner from 'components-stateless/Spinner';

export const SuspenseOutlet = () => (
  <Suspense fallback={<Spinner />}>
    <Outlet />
  </Suspense>
);
